<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout
        row
        wrap
      >
        <v-flex
          lg3
          sm3
        >
          <Menu />
        </v-flex>
        <v-flex
          lg9
          sm9
        >
          <v-row justify="center" class="mr-4" style="padding-top: 10px">
            <p>{{user?.name}} - {{user.sigla}}</p>
          </v-row>
          <router-view v-if="showPage"/>
          <ConsultaCpf v-else />
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Menu from "./Menu.vue";
import {mapActions} from "vuex";
import {router} from "@/router";
import AuthService from "@/services/sie-pedidos/auth.service";
import SolicitacaoService from "@/services/sie-pedidos/solicitacao.service";
import ConsultaCpf from "@/views/transportes/sie-pedidos/Entidade/Solicitacao/ConsultaCpf.vue";
const actions = mapActions('siePedidos', ['setDadosParaSolicitacao', 'setFormStep'])

export default {
  components: {
    ConsultaCpf,
    Menu
  },
  data: () =>({
    user: {name: null, sigla: null},
    showPage: true
  }),
  mounted() {
    this.getDadosUserLogado()
    this.setDadosLoginEntidade()
  },
  methods: {
    getDadosUserLogado(){
      AuthService.dadosUserLogado(false).then(result=>{
        if(result){
          const user = JSON.parse(localStorage.getItem("dadosUserLogado")) || {};
          this.user = user
        }else{
          router.push("/carteira-macrorregiao/entidade/login");
        }
      })
    },
    setDadosLoginEntidade(){
      SolicitacaoService.getDadosParaSolicitacao().subscribe(response=> {
          this.setDadosParaSolicitacao({dadosParaSolicitacao: { ...response?.result }})
        },
        error => {AuthService.removeAuth(true)}
      )
    },
    ...actions
  },
  watch: {
    $route(to, from) {
      if (to.name) {
        this.showPage = true;
      } else {
        this.showPage = false;
      }
    }
  }
};
</script>
